import { render, staticRenderFns } from "./hl10.vue?vue&type=template&id=04bd27f6&"
import script from "./hl10.vue?vue&type=script&lang=js&"
export * from "./hl10.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports